// extracted by mini-css-extract-plugin
export default {"file-display":"file_file-display__x7WnU","file-name":"file_file-name__LekMR","remove-button":"file_remove-button__mYdjg","disabled-button":"file_disabled-button__7wWk4"};